import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'app/shared/auth.service';
import { BackendService } from 'app/shared/backend.service';
import { NotificationService } from 'app/notification/notification.service';
import { DatePipe } from '@angular/common';

import CONFIG from 'config';
import { MatDialog } from '@angular/material/dialog';

//import { MomentDateModule, MomentDateAdapter } from '@angular/material-moment-adapter';
import { MomentDateModule, MomentDateAdapter } from '@angular/material-moment-adapter';
import * as _moment from 'moment';
const moment = _moment;

import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    //dateInput: 'YYYY/MM/DD',
    dateInput: 'DD-MM-YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
import 'moment/locale/ja';
import 'moment/locale/fr';
import { AppService } from 'app/app.service';
//import { MomentModule } from 'angular2-moment';
import { AlertmessageService } from 'app/shared/alertmessage.service';
@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css'],
  providers: [

    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
})
export class SignupComponent implements OnInit {
  customerID = new FormControl("(+868)-",[Validators.required]);
  //customerID = new FormControl("(+868)-");
  SignUp: FormGroup;
  Birthday = new FormControl();
  accounttype: any;
  Individual: boolean = false;
  Company: boolean = false;
  cancel: boolean = false;
  loadingData1: boolean = true;
  files: FileList;
  name: any;
  filestring: any;
  fileFormat: any;
  FileInput: string = 'E.g upload of scanned ID';
  DateIncorporated = new FormControl();
  countrycodes: any;
  selecctedidtype: any;
  Passport: boolean = false;
  DRIVERSPERMIT: boolean = false;
  IDENTITYCARD: boolean = false;
  NONPROVIDED: boolean = false;
  constructor(
    public _formBuilder: FormBuilder,
    public _router: Router,
    public _authService: AuthService,
    public _backendservice: BackendService,
    public _notificationService: NotificationService,
    public _datepipe: DatePipe,
    public _alert: AlertmessageService,
    public dialog: MatDialog,
    public _appService: AppService


  ) { }

  ngOnInit(): void {
    this.setForm();
    //this.cancel= false;
   // this.countryCodes();
    //this._appService.setUserLoggedIn(true);

    let currentDateTime =this._datepipe.transform((new Date));
  
    //console.log(currentDateTime);
    let t =new Date().toLocaleDateString();
    console.log(t)
  
    function getFormatedDateTime(date) {
      var dateFormated = new Date();
      console.log(dateFormated);
      return dateFormated.toLocaleDateString();
      
  };
  }

  countryCodes() {

    this._backendservice.getData(`${CONFIG.signupApiUrlBase}/countrycodes`)
      .subscribe(response => {
        // console.log(response);
        this.countrycodes = response['countrycodes'];
        // console.log( this.countrycodes)

      });
  }


  onSelectedCountry(event) {
    // console.log(event)
    this.selecctedidtype = event;
    console.log(this.selecctedidtype)
    if(this.selecctedidtype=="Passport"){
      this.Passport=true;
      this.DRIVERSPERMIT=false;
      this.IDENTITYCARD=false;
      this.NONPROVIDED=false;
    }
    if(this.selecctedidtype=="Driver’s Permit"){
      this.DRIVERSPERMIT=true;
      this.Passport=false;
      this.IDENTITYCARD=false;
      this.NONPROVIDED=false;
    }
    if(this.selecctedidtype=="Identity Card"){
      this.IDENTITYCARD=true;
      this.Passport=false;
      this.DRIVERSPERMIT=false;
      this.NONPROVIDED=false;
    }
    if(this.selecctedidtype=="NON PROVIDED"){
      this.NONPROVIDED=true;
      this.Passport=false;
      this.DRIVERSPERMIT=false;
      this.IDENTITYCARD=false;
    }
  }

  ClearFileds() {

    // console.log("testtt")
    this.cancel = true;
    this.Company = false;
    this.Individual = false;

    // this.radioChange(event);
  }
  radioChange(event) {
    //console.log(event.value);
    this.accounttype = event.value;
    //  console.log(this.accounttype);
    if (event.value == 0) {
      this.accounttype = "Individual";
      //console.log(this.accounttype);
      this.Individual = true;
      this.Company = false;
      return this.Individual;
    }

    else {
      this.accounttype = "Company"
      // console.log(this.accounttype);
      this.Company = true;
      this.Individual = false;
      return this.Company;
    }
  }

  onFileChange(event) {
    this.files = event.target.files;
    //console.log(this.files);
    this.name = this.files[0].name;
    this.fileFormat = this.files[0].type;
    //console.log(this.name);
    if (this.files[0].name.length < 30) {
      var str = this.files[0].name;
      this.FileInput = str.slice(0, 30);
    } else {
      var str = this.files[0].name;
      this.FileInput = str.slice(0, 25) + '...' + str.slice(-4);
    }
    //console.log(this.files);
    var reader = new FileReader();
    reader.onload = this._handleReaderLoadded.bind(this);
    reader.readAsBinaryString(this.files[0]);
  }
  _handleReaderLoadded(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.filestring = btoa(binaryString); //Convaerting Binary String Data
    //console.log(this.filestring);


  }
  dateSort(event) {
    console.log(event);
  }

  


  SignUpProcess(SignUpData) {
    this.loadingData1 = false;
    const bdate = new Date(SignUpData.Birthday);
    const bdate1 = new Date(SignUpData.DateIncorporated);

    //SignUpData.phonenumber = this.customerID.value;

    console.log(SignUpData);
    var msg = "";
    // if (this.accounttype == "Individual") {
    // console.log("Individual")

  
    if (SignUpData.MemberID == "" ) {
      //  console.log("lkjlfdjl")
      msg = msg + "\n ----MemberID";
    }
    if (SignUpData.Email == "") {
      msg = msg + "\n ---- Email Address";
    }
   
    if (SignUpData.Birthday == "") {
      msg = msg + "\n ---- Date Of Birth";
    }
   
    //console.log(this.selecctedidtype);
 
    // console.log(SignUpData.programmer);
    if (msg != "") {
      this.loadingData1 = true;
      this._alert.openConfirmationDialogTimeOut("Please enter all required fields");
      return true;
    }

   
   
 
    SignUpData.Birthday = this._datepipe.transform(SignUpData.Birthday.toString(), "M/d/yyyy");
    //SignUpData.expirydate = this._datepipe.transform(SignUpData.expirydate.toString(), "M/d/yyyy");
    //console.log(SignUpData.Birthday);

    console.log(SignUpData);
    this._backendservice.postData(SignUpData, `${CONFIG.signupApiUrlBase}`)
    .subscribe(
      response => {

        if (response['result']) {
         //console.log(response);
          //console.log("test");
          this.loadingData1 = true;
         
          //console.log(response)
          this._alert.openConfirmationDialogSignuUp(response['msg']);
       //  this._router.navigate(['/'])
        // window.alert("Submit Successfully.");
         
         
         //this.notificationService.showNotification({ message: response['msg'], type: 'success' });
          //this.setForm1();
        }
        else {
          this.loadingData1 = true;
      // console.log("test fail")
    // console.log(response)
          this.dialog.closeAll();
          //  this._alert.openConfirmationDialogSignuUpfield(response['msg']);
          this._alert.openConfirmationDialogSignuUp(response['msg']);
         // this._router.navigate(['/'])
        // this.notificationService.showNotification({ message: response['msg'], type: 'error' });
        }
      },
      (error) => {
        this.loadingData1 = true;
        this.dialog.closeAll();
        this._notificationService.showNotification({ type: 'error', message: 'Server Error' });
      });

    // }


  }
  setForm() {

    this.SignUp = new FormGroup({

      //hmbaccountnumber: new FormControl('', [Validators.required]),
      MemberID: new FormControl('', [Validators.required]),
     
      Email: new FormControl('', [Validators.required,Validators.pattern('^[a-zA-Z0-9]+[a-zA-Z0-9._]+@[a-zA-Z]+.[a-zA-Z]+$')]),
      Birthday: new FormControl('', [Validators.required]),
    });
  }
  setForm1() {

    this.SignUp = new FormGroup({
      MemberID: new FormControl(''),
      Email: new FormControl(''),
      Birthday: new FormControl(''),
     
      

    });
  }

}
